import { Button, styled } from '@mui/material';

export const TableButton = styled(Button)(() => ({
  backgroundColor: '#0086b7',
  padding: '1px 6px'
}));